// extracted by mini-css-extract-plugin
export default {"featureGrid":"statbar_featureGrid__GTK2L","featurePill":"statbar_featurePill__0YWUF","featureUsed":"statbar_featureUsed__zPjUv","featureUnused":"statbar_featureUnused__GFmqu"};